import 'bootstrap/dist/css/bootstrap.css';
import { Modal, FormSelect } from 'bootstrap-vue/es/components';
import './assets/css/site.css';
import Vue from 'vue';

// Added plugins for animation & validation
import VueSlideUpDown from 'vue-slide-up-down';
import VAnimateCss from 'v-animate-css';


// Added validation plugin
import VeeValidate, { Validator } from 'vee-validate';
// Added localization for validation
import { dictionary as hr } from './localization/hr';
import { dictionary as en } from './localization/en';
import { dictionary as hu } from './localization/hu';

// Added vuex i18n module
import vuexI18n from 'vuex-i18n';

import axios from 'axios';

import store from './store';

import App from './components/AppRoot';
import { FontAwesomeIcon } from './icons';

import translationsEn from './translations/general.en';
import translationsHr from './translations/general.hr';
import translationsHu from './translations/general.hu';

// initialize the internationalization plugin on the vue instance. note that
// the store must be passed to the plugin. the plugin will then generate some
// helper functions for components (i.e. this.$i18n.set, this.$t) and on the vue
// instance (i.e. Vue.i18n.set).
Vue.use(vuexI18n.plugin, store);
Vue.i18n.add('en-US', translationsEn);
Vue.i18n.add('hr-HR', translationsHr);
Vue.i18n.add('hu-HU', translationsHu);
Vue.i18n.fallback('en-US');
Vue.i18n.set('hr-HR');

// Registration of global components
Vue.component('icon', FontAwesomeIcon);
Vue.component('vue-slide-up-down', VueSlideUpDown);

Vue.use(Modal);
Vue.use(FormSelect);
Vue.use(VAnimateCss);

// Localize takes the locale object as the second argument (optional) and merges it.
Validator.localize('en', en);
Validator.localize('hu', hu);
Validator.localize('hr', hr);
Vue.use(VeeValidate);


// Global settings for Axios
Vue.prototype.$http = axios;

// Axios Base URL
axios.defaults.baseURL = process.env.VUE_APP_URL;

// mogli smo i bez tih postavki
axios.defaults.headers.post['Accept'] = 'text/plain';
axios.defaults.headers.post['Content-Type'] = 'application/json';

//Set current language
axios.interceptors.request.use(function (config) {
    if (config.url.includes('?'))
        config.url += `&culture=${store.state.i18n.locale}`;
    else
        config.url += `?culture=${store.state.i18n.locale}`;

    return config;
}, function (error) {
    // Do something with request error
    return Promise.reject(error);
});

Vue.config.productionTip = true;

new Vue({
    store,
    ...App,
    render: h => h(App)
}).$mount('#app');
